import { render, staticRenderFns } from "./ApplicationSent.vue?vue&type=template&id=40a4344a&scoped=true&"
import script from "./ApplicationSent.vue?vue&type=script&lang=ts&"
export * from "./ApplicationSent.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationSent.vue?vue&type=style&index=0&id=40a4344a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a4344a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
